import React, { lazy, Suspense } from "react";

const LazyPrintTenants = lazy(() => import("./PrintTenants"));
const LazyTenantList = lazy(() => import("./TenantList"));
const LazyTenantViewContract = lazy(() => import("./TenantView_Contract"));
const LazyTenantViewParadan = lazy(() => import("./Tenant_ViewParadan"));
const LazyTenantViewTakeMoney = lazy(() => import("./Tenant_ViewTakeMoney"));
const LazyExpireTenantList = lazy(() => import("./ExpireTenantList"));
const LazyOnTimeTenantList = lazy(() => import("./OnTimeTenantList"));
const LazyPrintExpireTenant = lazy(() => import("./PrintExpireTenant"));
const LazyPrintOnTimeTenants = lazy(() => import("./PrintOnTimeTenants"));
export const PrintExpireTenant = () => (
  <Suspense fallback="loading...">
    <LazyPrintExpireTenant />
  </Suspense>
);
export const PrintOnTimeTenants = () => (
  <Suspense fallback="loading...">
    <LazyPrintOnTimeTenants />
  </Suspense>
);
export const ExpireTenantList = () => (
  <Suspense fallback="loading...">
    <LazyExpireTenantList />
  </Suspense>
);
export const OnTimeTenantList = () => (
  <Suspense fallback="loading...">
    <LazyOnTimeTenantList />
  </Suspense>
);
export const PrintTenants = () => (
  <Suspense fallback="loading...">
    <LazyPrintTenants />
  </Suspense>
);
export const TenantList = () => (
  <Suspense fallback="loading...">
    <LazyTenantList />
  </Suspense>
);
export const TenantView_Contract = () => (
  <Suspense fallback="loading...">
    <LazyTenantViewContract />
  </Suspense>
);
export const Tenant_ViewParadan = () => (
  <Suspense fallback="loading...">
    <LazyTenantViewParadan />
  </Suspense>
);
export const Tenant_ViewTakeMoney = () => (
  <Suspense fallback="loading...">
    <LazyTenantViewTakeMoney />
  </Suspense>
);
